
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-editable-table-section',
  standalone: true,
  imports: [],
  templateUrl: './editable-table-section.component.html',
  styleUrl: './editable-table-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditableTableSectionComponent {
  @Input() sectionTitle = '';
  @Input() expanded = false;
  /** When false, omit pt-3 border-top (e.g. for the first section). */
  @Input() addTopBorder = true;
  @Input() showEditButton = true;
  @Input() editing = false;
  @Input() isSaving = false;
  @Input() saveDisabled = false;
  @Input() editButtonTitle = 'Edit';
  @Input() hasRows = false;
  @Input() hasRowsMarkedForDelete = false;
  /** Shown when in edit mode with no rows (or in view mode if viewEmptyMessage is not set). */
  @Input() emptyMessage = '';
  /** Optional: when in view mode with no rows, show this instead of emptyMessage (e.g. "No demand rates found for this schedule."). */
  @Input() viewEmptyMessage: string | null = null;
  @Input() allRowsDeletedMessage = '';

  @Output() toggle = new EventEmitter<void>();
  @Output() enterEdit = new EventEmitter<void>();
  @Output() cancelEdit = new EventEmitter<void>();
  @Output() addRow = new EventEmitter<void>();
  @Output() save = new EventEmitter<void>();

  onToggle(): void {
    this.toggle.emit();
  }

  onEnterEdit(): void {
    this.enterEdit.emit();
  }

  onCancelEdit(): void {
    this.cancelEdit.emit();
  }

  onAddRow(): void {
    this.addRow.emit();
  }

  onSave(): void {
    this.save.emit();
  }
}
